var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "a-folder-breadcrumb" },
    [
      _c(
        "a",
        {
          staticClass: "a-folder-breadcrumb__home",
          attrs: { href: "#", title: _vm.homeTitle },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("goTo", { id: null, index: 0 })
            },
          },
        },
        [_c("HouseIcon", { attrs: { width: 16, height: 16 } })],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.breadcrumbs, function (item, index) {
        return [
          _c(
            "span",
            {
              key: `sep-${index}`,
              staticClass: "a-folder-breadcrumb__separator",
            },
            [_vm._v("/")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              key: item.id,
              staticClass: "a-folder-breadcrumb__link",
              attrs: { href: "#", title: item.text },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.go(item.id, index + 1)
                },
              },
            },
            [_vm._v(_vm._s(item.text))]
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }